<template>
    <div class="mallIndex">
      <!-- 日期切换 -->
      <ul class="tabData clearfix">
        <li v-for="(item,index) in tabData.textArr" @click="tabLi(index)" :class="{on:tabData.nowIndex==index}">{{item}}</li>
      </ul>

      <!-- 五大模块 -->
      <ul class="fiveMode clearfix">
        <li v-for="(item,index) in fiveMode">
          <p class="fmTit">{{item.fmTit}}</p>
          <p class="fmNum">{{item.fmNum}}</p>
          <p class="contrast">同比：↑{{item.contrast}}%</p>
        </li>
      </ul>

      <!-- 销量趋势图 + 销量排行榜 -->
      <div class="saleWrap flex-row jus-b">
        <!-- 趋势图 -->
        <sale-echart></sale-echart>

        <!-- 销售排行榜 -->
        <sale-list></sale-list>
      </div>

      <!-- 导航选择 -->
      <ul class="navSelect clearfix">
        <li><img src='../../assets/nav1.png' alt=""></li>
        <li><img src='../../assets/nav2.png' alt=""></li>
        <li><img src='../../assets/nav3.png' alt=""></li>
        <li><img src='../../assets/nav4.png' alt=""></li>
        <li><img src='../../assets/nav5.png' alt=""></li>
        <li><img src='../../assets/nav6.png' alt=""></li>
      </ul>
    </div>
</template>

<script>
    import saleEchart from './SaleEchart/SaleEchart';
    import saleList from './SaleList/SaleList';

    export default {
        name: "index",
        data() {
        return {
            // 日期切换
            tabData:{
              textArr:['昨日','本周','本月'],
              nowIndex:0
            },
            fiveMode:[
              {fmTit:'收入',fmNum:68790.00,contrast:12},
              {fmTit:'下单数',fmNum:4836,contrast:12},
              {fmTit:'访客数',fmNum:5142,contrast:12},
              {fmTit:'浏览数',fmNum:6498,contrast:12},
              {fmTit:'售后单数',fmNum:9,contrast:12}
            ]
          }
        },
        methods: {
          //  日期切换
          tabLi(nowIndex) {
            this.tabData.nowIndex = nowIndex;
          }
        },
      components:{
        saleEchart,
        saleList
      }
    }
</script>

<style scoped>
  .mallIndex{
    padding-bottom: 92px;
  }
  /*日期切换*/
  .tabData{
    background: #fff;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
  .tabData li{
    float: left;
    width: 80px;
    color:#7F7F7F;
    font-size: 12px;
    cursor: pointer;
    position: relative;
  }
  .tabData li:after{
    content: '';
    position: absolute;
    width: 80px;
    height: 4px;
    background: transparent;
    bottom: -4px;
    left: 0;
  }
  .tabData li.on:after{
    background: #F99A1A;
  }

  /*五大模块*/
  .fiveMode{
    margin-top: 18px;
  }
  .fiveMode li{
    float: left;
    width: 19%;
    height: 144px;
    padding-top: 14px;
    padding-left: 16px;
    background: url("../../assets/fm1.png") no-repeat;
    background-size: 100% 100%;
    color:#FBFBFB;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .fiveMode li:nth-child(2){
    background-image: url("../../assets/fm2.png");
  }
  .fiveMode li:nth-child(3){
    background-image: url("../../assets/fm3.png");
  }
  .fiveMode li:nth-child(4){
    background-image: url("../../assets/fm4.png");
  }
  .fiveMode li:nth-child(5){
    background-image: url("../../assets/fm5.png");
  }
  .fiveMode li+li{
    margin-left: 12px;
  }
  .fiveMode li .fmTit{
    font-size: 18px;
    font-weight: bold;
  }
  .fiveMode li .fmNum{
    font-size: 44px;
    font-weight: bold;
    margin-top: 9px;
    height: 59px;
    line-height: 59px;
  }
  .fiveMode li .contrast{
    font-size: 15px;
    margin-top: 6px;
  }

  /* 销量趋势图和销量排行 */
  .saleWrap{
    height: 544px;
    margin-top: 14px;
  }

  /* 底部选择 */
  .navSelect{
    margin-top: 12px;
    height: 140px;
    padding-top: 20px;
    background: #fff;
    -webkit-border-radius: 12px;
    -moz-border-radius: 12px;
    border-radius: 12px;
  }
  .navSelect li{
    float: left;
    width: 120px;
    height: 120px;
    margin-left: 20px;
    cursor: pointer;
  }
  .navSelect li img{
    width: 100%;
    height: 100%;
  }
</style>
